import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { Box, Switch } from "@mui/material";
import ViewInArOutlinedIcon from "@mui/icons-material/ViewInArOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import StyledProductsTable from "./StyledProductsTable";
import { fetchEditProducts } from "../../../store/reducers/createProfile";
import NoDataFound from "../../../pages/PrivateDashboard/NoDataFound";
import CollapsibleTable from "../CollapsibleTable";
import { createProductsData } from "../CollapsibleTable/dataFunctions";
import rollbar from "../../../rollbarConfig";
import wanderobelogo from "../../../assets/images/WanderobeLogoNoImagePlaceholder.svg";

const ProductsTable = ({
  data,
  loading,
  paginationData,
  setPageSize,
  count,
  pageSize,
  setCount,
  onEdit,
  onDelete,
  onDetails,
}) => {
  const [activeStates, setActiveStates] = useState({});
  const dispatch = useDispatch();
  const heading = [
    "Product Name",
    "Product Id",
    "Total QYT.",
    "Sold QYT.",
    "Available QYT.",
    "status",
    "Action",
  ];

  const handleToggle = async (productId) => {
    const newStatus = !activeStates[productId] ? "A" : "In";
    setActiveStates((prev) => ({
      ...prev,
      [productId]: !prev[productId],
    }));

    try {
      const requestData = {
        id: productId,
        dataToSend: { status: newStatus },
      };
      const res = await dispatch(fetchEditProducts(requestData));
      console.log("Edit response:", res);
    } catch (err) {
      rollbar.error("Error message", err);
      console.error("Error updating status:", err);
    }
  };

  useEffect(() => {
    if (data?.length > 0) {
      const initialStates = data?.reduce((acc, product) => {
        acc[product.id] = product.status === "A";
        return acc;
      }, {});
      setActiveStates(initialStates);
    }
  }, [data]);

  const paymentRows = data?.map((item) =>
    createProductsData(
      <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
        {item?.variants?.[0]?.variant_img?.[0] || item?.images?.[0] ? (
        <Box
          component='img'
          src={item?.images?.[0] || item?.variants?.[0]?.variant_img?.[0]}
          alt={item?.name}
          sx={{
            height: 40,
            width: 40,
            objectFit: "contain",
            border: "0.62px solid #CBCBCB",
          }}
        />
        ) : (
          <Box
            component='img'
            src={wanderobelogo}
            alt={item?.name}
            sx={{
              height: 40,
              width: 40,
              opacity: 0.3,
              objectFit: "contain",
              border: "0.62px solid #CBCBCB"
            }}
          />
        )}
        <span className='text-truncate'>{item?.name}</span>
      </Box>,
      item?.id,
      item?.quantity + item?.sold_qty,
      item?.sold_qty,
      item?.quantity,
      <StyledProductsTable>
        <Box sx={{ minWidth: "115px", display: "flex", alignItems: "center" }}>
          <Switch
            className={`custom-switch ${activeStates[item?.id] ? "active1" : ""}`}
            checked={activeStates[item?.id] || false}
            onChange={() => handleToggle(item?.id)}
          />
          <Box className='custom-switch-text'>
            {activeStates[item?.id] ? "Active" : "Inactive"}
          </Box>
        </Box>
      </StyledProductsTable>,
      <Box sx={{ display: "flex", gap: "20px", alignItems: "center" }}>
        <RemoveRedEyeOutlinedIcon
          sx={{ cursor: "pointer", color: "#050505", fontSize: "24px" }}
          onClick={() => onDetails?.(item?.id)}
        />
        <EditOutlinedIcon
          sx={{ cursor: "pointer", color: "#050505", fontSize: "24px" }}
          onClick={() => onEdit?.(item?.id)}
        />
        <DeleteOutlineIcon
          sx={{ cursor: "pointer", color: "#B60218", fontSize: "24px" }}
          onClick={() => onDelete?.(item?.id)}
        />
      </Box>
    )
  );

  return (
    <CollapsibleTable
      loading={loading}
      noDataComponent={
        <NoDataFound
          icon={<ViewInArOutlinedIcon className='icon-no-data' />}
          heading='No Products Found!'
          subHeading='No products are generated for you now.'
        />
      }
      showPagination={true}
      headings={heading}
      rows={paymentRows}
      isDownIconVisible={false}
      totalCount={paginationData?.total_count}
      totalPages={paginationData?.total_pages}
      pageNo={count}
      pageSize={
        paginationData?.total_count >= 10
          ? pageSize
          : paginationData?.total_count
      }
      setPageNo={setCount}
      setPageSize={setPageSize}
      openProductDetails={(i) => onDetails(data[i].id)}
      viewDetailsShow={true}
    />
  );
};

export default ProductsTable;
